import { render, staticRenderFns } from "./Institution.vue?vue&type=template&id=69cfe621&scoped=true"
import script from "./Institution.vue?vue&type=script&lang=js"
export * from "./Institution.vue?vue&type=script&lang=js"
import style0 from "./Institution.vue?vue&type=style&index=0&id=69cfe621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfe621",
  null
  
)

export default component.exports